import type { Lang, LorsCopy } from "./translations";

export const aug4Headlines: string[] = [
  "The One Step Most Homeowners Skip That Sends Their Loved Ones to Probate Court",
  "The Assumption That Costs Families Thousands of Dollars and Months In Court",
  "The Tools That Actually Work To Protect Your Family From Spending Thousands in Probate Court",
  "Join Us to Understand the Difference Between Wills and Trusts, And How to Keep Your Family From Probate Court",
  "The Tools That Actually Work To Protect Your Family From Spending Thousands in Probate Court",
  "Discover Why a Will Doesn't Keep Your Family From Spending Thousands in Probate Court",
  "Discover Why a Will Doesn't Keep Your Family From Spending Thousands in Probate Court",
  "Discover Why a Will Doesn't Keep Your Family From Spending Thousands in Probate Court",
  "Discover Why a Will Doesn't Keep Your Family From Spending Thousands in Probate Court",
  "The One Step Most Homeowners Skip That Sends Their Loved Ones to Probate Court",
];


const content = {
  en: {
    eyebrow: "Free Estate Planning Workshop",
    headline:
      "National Make-A-Will Month: Is a Will Enough to Protect Your Family?",
    headlineBreakBefore: "Protect Your Family?",
    subhead:
      "Join us for a free in-person event to help your family avoid court, conflict & confusion.",
    subheadLabel: "A note from Ruby:",
    learnTitle: "What Most Families Don't Realize Until It's Too Late",
    learnItems: [
      "Your will won't keep your family out of probate, and what you need instead",
      "There is one document all homeowners must have to transfer their home quickly, so their family isn't stuck in a year-long legal battle",
      "Your spouse may not be able to sell your house or access your joint bank accounts without the right documents in place",
      "Why the legal mess your family inherits is almost always preventable, if you understand the California laws",
    ],
    quote:
      "Ruby Steinbrecher was fantastic. The family trust workshop was clear, informative, and extremely helpful for getting started with estate planning.",
    quoteAttribution: "Shawn H., Workshop Attendee",
    formDate: { short: "Tue, Aug 4th", long: "Tuesday, August 4th" },
    formTime: "4:00–5:00 PM",
    formVenueLine1: "Santa Rosa Veteran's Memorial Building (Lodge Room)",
    formVenueLine2: "1351 Maple Ave, Santa Rosa, CA 95404",
    formTitle: "Reserve Your Seat",
    formSubtitle: "Free to attend. Limited seating available.",
    formFirstName: "First name",
    formLastName: "Last name",
    formEmail: "Email",
    formPhone: "Phone",
    formSmsConsent:
      "I consent to receive text messages from the Law Office of Ruby Steinbrecher about this event, and occasional marketing messages. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.",
    formEnewsConsent:
      "I'd like to receive occasional email updates from the Law Office of Ruby Steinbrecher.",
    formPrivacy: "Privacy Policy",
    formSubmit: "Reserve My Seat",
    formSubmitting: "Reserving your seat…",
    formTrust: "⭐ Trusted by local families | 81 Five-Star Reviews",
    getDirections: "Get Directions",
    footerCopyright: "© 2026 Ruby Steinbrecher",
    footerPrivacy: "Privacy Policy",
    testimonialsTitle: "What Families Are Saying",
    aboutTitle: "Meet Ruby Steinbrecher",
    aboutRole: "Attorney",
    aboutBody: [
      "I have practiced law since 2007, first working at a medium-sized firm in San Francisco handling civil litigation, and then moving into estate planning, small business and contract law since 2010. I value people, the planet, and prosperity that does not adversely affect the former.",
      "Prior to entering the legal field, I had a variety of business and life experience that has only enhanced my ability to serve clients: Road Manager for Ken Kesey's bus trip to Great Britain in 1999, Human Resources at a tech startup in 2001, recognized for my work as a Case Manager at Casey Family Programs with disadvantaged youth in the foster care system in Oakland and the wider San Francisco-Bay Area in the early 2000's.",
      "Currently, I live in Sebastopol with my daughter, husband, and a menagerie of pets, where I enjoy gardening as it keeps me grounded and enjoying the beautiful weather.",
    ],
    registrationTitle: "Ready to Secure Your Family's Future?",
    registrationSub: "Free to attend. Limited seating available.",
    registrationCta: "Save My Seat",
    registrationFoot:
      "No pressure. Just clear information so you can make the right decision for your family.",
    errorTitle: "Something went wrong",
    errorBody:
      "We couldn't reserve your seat. Please try again or call our office.",
    validation: {
      firstName: "First name is required",
      lastName: "Last name is required",
      email: "Enter a valid email",
      phone: "Enter a valid phone number",
    },
    timeAgo: {
      monthAgo: "a month ago",
      monthsAgo: (n: number) => `${n} months ago`,
      yearAgo: "a year ago",
    },
  },
};

export const lorsContentAug4 = { en: content.en, es: content.en } as unknown as Record<Lang, LorsCopy>;
